/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { markupContentStyles, syntaxHighlightStyles } from 'src/styles/markup';

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${gridSize() * 4}px;

  > img {
    align-self: center;
    border: 1px solid ${token('color.border', colors.N40)};
    max-width: 100%;

    /* IE11 fix */
    flex-shrink: 0;
  }
`;

export const MarkupWrapper = styled.div`
  padding: ${gridSize() * 2}px;
  ${markupContentStyles};
  ${syntaxHighlightStyles};
`;
